import api from '../../api'

const SET_PERIODS = 'SET_PERIODS'
const ADD_PERIOD = 'ADD_PERIOD'

export default {
  namespaced: true,
  state: {
    periods: {}
  },
  mutations: {
    [SET_PERIODS]: (state, periods) => {
      state.periods = periods
    },
    [ADD_PERIOD]: (state, period) => {
      let item = {}
      item[period.code] = period
      state.periods = Object.assign({}, state.periods, item)
    }
  },
  actions: {
    getPeriods: async ({commit}) => {
      let response = await api.periods.list()
      if (response.success) {
        commit(SET_PERIODS, response.periods)
      } else {
        throw new Error(response.message || 'Произошла ошибка при загрузке списка доступных периодов')
      }
    },
    savePeriod: async ({commit}, period) => {
      let response = await api.periods.save(period)
      if (response.success) {
        commit(ADD_PERIOD, response.period)
      }
    }
  },
  getters: {
    periods (state) {
      return state.periods
    }
  }
}
